import { activities } from "./activities"
import { common } from "./common"
import { courses } from "./courses"
import { name } from "./name"
import { subjects } from "./subjects"
import { work } from "./work"
import mixpanel from "mixpanel-browser"

export interface CommonProps {
  email: string
  name: string
  version: number
  organization: string
}

export type EventWithCount<T extends string> = CommonProps & {
  [key in T]: number
}

export function trackEvent(event: ONBOARDING_EVENTS, props: CommonProps | EventWithCount<string>) {
  mixpanel.track(event, { ...props })
}

export enum ONBOARDING_EVENTS {
  LAND = "Student land on onboarding",
  STARTED = "Student press start onboarding",
  CHOOSE_YOUR_NAME_LAND = "Student land on choose your name page",
  CHOOSE_YOUR_NAME_GO_EDIT = "Student edit name",
  CHOOSE_YOUR_NAME_SUBMIT = "Student press continue button",
  WORK_LAND = "Student land on work page",
  SELECT_HE_WORK = "Student select he/she/they work",
  SELECT_HE_DID_NOT_WORK = "Student select he/she/they did not work",
  WORK_ADD_EVENT = "Student save work event",
  WORK_REMOVE_EVENT = "Student remove work event",
  WORK_KEEP_SAVING = "Student keep saving work events",
  WORK_GO_BACK = "Student select go back to choose name page",

  SELECT_SUBJECT_TITLE = "Student select subject title",

  REMOVE_COURSE_EVENT = "Student remove course event",

  LAND_ADD_ACTIVITIES = "Student land on add activities and recreation page",
  ACTIVITIES_GO_BACK = "Student go back to work page",
  HAVE_OTHER_ACTIVITIES = "Student select have other activities",
  HAVE_NOT_ACTIVITIES = "Student select have not activities",
  SELECT_ACTIVITY_TITLE = "Student select activity title",
  WRITE_ACTIVITY_TITLE = "Student write activity title",
  ADD_ACTIVITY_EVENT = "Student add activity event",
  REMOVE_ACTIVITY_EVENT = "Student remove activity event",
  KEEP_SAVING_ACTIVITY_EVENTS = "Student keep saving activity events",

  ONBOARDING_COMPLETE = "Student complete onboarding",
}

const onboarding = {
  common,
  work,
  subjects,
  courses,
  activities,
  name,
}

export default onboarding
